class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper ? this.domNodes.headerWrapper.offsetTop : 0;
    this.headerHeight = this.domNodes.headerWrapper ? this.domNodes.headerWrapper.offsetHeight : 0;
    this.stickyHeader = this.dataset.sticky;
    this.auraHideOffset = Number(this.dataset.auraHideOffset || 20);
    this.lastScroll = 0;
    this.stickyScrollHandler = null;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
      atTop: "header-at-top",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.headerHeight = this.domNodes.headerWrapper ? this.domNodes.headerWrapper.offsetHeight : this.headerHeight;
      this.handleSticky();
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  getExtraSpace() {
    let extraSpace = this.auraHideOffset;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;
    return extraSpace;
  }

  resetToTop() {
    this.classList.add(this.classes.atTop);
    this.classList.remove(this.classes.scrollUp, this.classes.scrollDown, this.classes.stuck, this.classes.always);
    document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
  }

  handleSticky() {
    if (this.stickyScrollHandler) {
      window.removeEventListener("scroll", this.stickyScrollHandler);
    }

    this.headerHeight = this.domNodes.headerWrapper ? this.domNodes.headerWrapper.offsetHeight : this.headerHeight;
    this.lastScroll = window.scrollY;

    this.stickyScrollHandler = () => {
      const currentScroll = window.scrollY;
      const extraSpace = this.getExtraSpace();

      if (currentScroll <= extraSpace) {
        this.resetToTop();
        this.lastScroll = currentScroll;
        return;
      }

      this.classList.remove(this.classes.atTop);

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > this.lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < this.lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }

      this.lastScroll = currentScroll;
    };

    this.stickyScrollHandler();
    window.addEventListener("scroll", this.stickyScrollHandler, { passive: true });
  }
}

if (!customElements.get("m-header")) {
  customElements.define("m-header", MHeader);
}
